import { Card as AntdCard, Col, Row } from "antd";
import React, { JSX, ReactNode } from "react";
import styled from "styled-components";

export interface OrderFormSectionProps {
  title: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
}

const Card = styled(AntdCard)`
  margin-top: 24px;
  box-shadow: 0 4px 6px -1px #0000001a, 0 2px 4px -2px #0000001a;

 .title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 6px;


  .subtitle {
    margin: 12px 0;
  }
`;

const OrderFormSection = (props: OrderFormSectionProps): JSX.Element => {
  return (
    <Card>
      <Row gutter={{ lg: 6 }}>
        <Col span={24} lg={10}>
          <div className='title'>{props.title}</div>
          {props.subtitle && <div className='subtitle'>{props.subtitle}</div>}
        </Col>
        <Col span={24} lg={14}>
          {props.children}
        </Col>
      </Row>
    </Card>
  );
}

export default OrderFormSection;
